import script from "./Patrocinadores.vue?vue&type=script&setup=true&lang=js"
export * from "./Patrocinadores.vue?vue&type=script&setup=true&lang=js"

import "./Patrocinadores.vue?vue&type=style&index=0&id=7e708c46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e708c46"]])

export default __exports__